export default {
    nftContract : "0x37643c0F2a9E64957559afCDf5fE509EA0ad626f",
    // stakingContract:"0x2fDdaC6b94FEe743a8c5bE0F81373e91944d12a2"
}